package ui.theme

import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import models.Wonder

val bgColor: Color
    get() = pinkBg

val fgColor: Color
    get() = Color(0xFFF0F8FF)

val Color.colorFilter: ColorFilter
    get() = ColorFilter.tint(this, BlendMode.SrcIn)


fun Color.Companion.fromHex(hex: String) = Color(
    ("ff" + hex.removePrefix("#").lowercase()).toLong(16)
)